module.exports = "pegasus/assets/background-patterns/gray-play.png";